"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerCreditDataDelayedPaymentEntriesToJSON = exports.CustomerCreditDataDelayedPaymentEntriesFromJSONTyped = exports.CustomerCreditDataDelayedPaymentEntriesFromJSON = void 0;
var _1 = require("./");
function CustomerCreditDataDelayedPaymentEntriesFromJSON(json) {
    return CustomerCreditDataDelayedPaymentEntriesFromJSONTyped(json, false);
}
exports.CustomerCreditDataDelayedPaymentEntriesFromJSON = CustomerCreditDataDelayedPaymentEntriesFromJSON;
function CustomerCreditDataDelayedPaymentEntriesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'shoppingDate': (new Date(json['shoppingDate'])),
        'amount': (0, _1.AmountFromJSON)(json['amount']),
        'dueToDate': (new Date(json['dueToDate'])),
    };
}
exports.CustomerCreditDataDelayedPaymentEntriesFromJSONTyped = CustomerCreditDataDelayedPaymentEntriesFromJSONTyped;
function CustomerCreditDataDelayedPaymentEntriesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'shoppingDate': (value.shoppingDate.toISOString().substr(0, 10)),
        'amount': (0, _1.AmountToJSON)(value.amount),
        'dueToDate': (value.dueToDate.toISOString().substr(0, 10)),
    };
}
exports.CustomerCreditDataDelayedPaymentEntriesToJSON = CustomerCreditDataDelayedPaymentEntriesToJSON;
//# sourceMappingURL=CustomerCreditDataDelayedPaymentEntries.js.map